















import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardBarDrawable, IWizardBarDrawable, instanceOfIWizardSizeSpecifiable, IWizardSizeSpecifiable } from "../../../../../../domain/format";
import { BarInput } from "../../../../../drawing";
import { NumberInputtableContentMixin } from "./mixins";
import { FatalIndicator } from "./common";

@Component({
  components: {
    BarInput,
    FatalIndicator,
  }
})
export default class WizardContentBarInput extends Mixins(NumberInputtableContentMixin) {
  get valueAsNumber(): number {
    return parseFloat(this.text);
  }

  set valueAsNumber(source: number) {
    this.text = source.toString();
  }

  get drawer(): IWizardBarDrawable & IWizardSizeSpecifiable {
    return (instanceOfIWizardBarDrawable(this.content) && instanceOfIWizardSizeSpecifiable(this.content))
      ? this.content
      : null;
  }
}
